// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2e4238a2","977":"8c32f8dd"}[chunkId] + ".chunk.js";
};